// Преобразование даты из формата дд.мм.гггг в ISO формат с текущим временем по часовому поясу Владивостока
export const convertDateToISO = (dateString: string): string => {
    const parts = dateString.split('.');
    if (parts.length !== 3) {
        return '';
    }
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    
    const now = new Date();
    
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Vladivostok',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
    
    const partsTime = formatter.formatToParts(now);
    const currentHours = parseInt(partsTime.find(part => part.type === 'hour')?.value || '0', 10);
    const currentMinutes = parseInt(partsTime.find(part => part.type === 'minute')?.value || '0', 10);
    
    const dateTimeString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(currentHours).padStart(2, '0')}:${String(currentMinutes).padStart(2, '0')}:00`;
    
    const vladivostokDate = new Date(dateTimeString + '+10:00');
    
    return vladivostokDate.toISOString();
};

// Преобразование телефона в формат +79990099090
export const normalizePhone = (phone: string): string => {
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 11 && digits[0] === '8') {
        return '+7' + digits.substring(1);
    }
    if (digits.length === 11 && digits[0] === '7') {
        return '+' + digits;
    }
    if (digits.length === 10) {
        return '+7' + digits;
    }
    return phone.startsWith('+') ? phone : '+' + digits;
};

export interface BookingRequestData {
    phone: string;
    date: string;
    services: string[];
    customService?: string;
    blockName: string;
}

export interface CostRequestData {
    phone: string;
    date: string;
    blockName: string;
    contactMethod: string;
    brandModel: string;
    carYear: string;
}

export interface BookingResponse {
    success: boolean;
    error?: string;
}

// Отправка данных заявки в телеграм-бот
export const sendBookingRequest = async (data: BookingRequestData): Promise<BookingResponse> => {
    try {
        const normalizedPhone = normalizePhone(data.phone);
        const isoDate = convertDateToISO(data.date);
        
        const metadata: Record<string, string> = {
            'Блок': data.blockName,
        };
        
        if (data.services.length > 0) {
            metadata['Услуга'] = data.services.join(', ');
        } else if (data.customService && data.customService.trim()) {
            metadata['Услуга'] = data.customService.trim();
        }
        
        const requestData = {
            phone: normalizedPhone,
            desired_data: isoDate,
            metadata: metadata,
            source: 'AGC'
        };
        
        const response = await fetch('https://autogarantcity.ru/api/v1/request', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        });
        
        if (!response.ok) {
            throw new Error('Ошибка при отправке данных');
        }
        
        return { success: true };
    } catch (error) {
        console.error('Ошибка при отправке заявки:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.'
        };
    }
};

export const sendCostRequest = async (data: CostRequestData): Promise<BookingResponse> => {
    try {
        const normalizedPhone = normalizePhone(data.phone);
        const isoDate = convertDateToISO(data.date);

        const metadata: Record<string, string> = {
            'Блок': data.blockName,
        };

        metadata['Марка и модель машины'] = data.brandModel;
        metadata['Год выпуска машины'] = data.carYear;
        metadata['Предпочтительный способ связи'] = data.contactMethod;

        const requestData = {
            phone: normalizedPhone,
            desired_data: isoDate,
            metadata: metadata,
            source: 'AGC'
        };

        const response = await fetch('https://autogarantcity.ru/api/v1/request', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        });

        if (!response.ok) {
            throw new Error('Ошибка при отправке данных');
        }

        return { success: true };
    } catch (error) {
        console.error('Ошибка при отправке заявки:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.'
        };
    }
};